import SvgIcon from "../svg-icon";

const InformationToast = props => {

    // 'ti-check' : 'ti-error-404' , "ti-info-circle", ti-x


    const {title, message, icon = "ti-info-circle"} = props
    return (
        <div
            className="toast show"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
        >
            <div className="toast-header">
                <strong className="me-auto">
                    <SvgIcon id={icon}/>

                    {title}
                </strong>
            </div>
            <div className="toast-body message small">
                {message}
            </div>
        </div>

    )

}

export default InformationToast
